/**
 * Bloque CTA presentacional para rutas de suscripción (sin lógica de negocio).
 */
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export function UpgradeCTA({ heading, body, buttonLabel, to, className = "" }) {
  return (
    <div
      className={`rounded-xl border border-sky-200 bg-gradient-to-r from-sky-50/90 to-white px-4 py-4 sm:px-5 sm:py-4 shadow-sm ${className}`}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          {heading ? (
            <p className="font-semibold text-slate-800 text-sm sm:text-base leading-snug">{heading}</p>
          ) : null}
          {body ? <p className="text-xs sm:text-sm text-slate-600 mt-1">{body}</p> : null}
        </div>
        <Button asChild className="shrink-0 bg-sky-600 hover:bg-sky-700 text-white">
          <Link to={to}>{buttonLabel}</Link>
        </Button>
      </div>
    </div>
  );
}
